const getIsMobileDevice = () => {
  const userAgent = window.navigator.userAgent;

  return userAgent.includes('Mobile') || userAgent.includes('Tablet');
};

export default getIsMobileDevice;
